import PropTypes from "prop-types"

import RichText from "@components/rich-text/renderer"
import Pager from "@components/navigation/pager"
import PressSidebar from "@components/press/sidebar"
import PageMenu from "@components/navigation/menus/page-menu"
import StyledHero from "@components/StyledHero"

import { section, row } from "../../templates/press.module.css"

const PressIndex = ({ baseUrl, pageContext, data, children }) => (
  <>
    <StyledHero>
      <RichText body={data.heroText.rtContent} mikan={data.heroText.mikan} />
    </StyledHero>
    <PageMenu links={data.pageMenu.link} />
    <section className={section}>
      <div className={row}>
        <div>
          {children}
          <Pager currentPage={pageContext.currentPage} numPages={pageContext.numPages} baseUrl={baseUrl} />
        </div>
        <PressSidebar />
      </div>
    </section>
  </>
)

PressIndex.propTypes = {
  title: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  pageContext: PropTypes.shape({
    currentPage: PropTypes.number,
    numPages: PropTypes.number,
  }),
  data: PropTypes.shape({
    heroText: PropTypes.object.isRequired,
    pageMenu: PropTypes.object.isRequired,
  }),
}

export default PressIndex
